export const FRAMEWORK_ADMIN_ROLE = 'framework-admin';
export const INSTANCE_ADMIN_ROLE = 'instance-admin';
